export class PiperingFamilyModel {
    _id: string;
    id: number;
    name: string;
    description: string;
    graphicalRepresantation: string;

    constructor(id = null,
        _id = '',
        name = '',
        description = '',
        graphicalRepresantation = 'HINGE_SCREW') {
            this._id = _id;
            this.id = id;
            this.name = name;
            this.description = description;
            this.graphicalRepresantation = graphicalRepresantation;
    }
}
